var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
var StyledPresence = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\ttransition: all ", "ms ease-in;\n"], ["\n\ttransition: all ", "ms ease-in;\n"])), function (props) { return props.timeout; });
var ElementState;
(function (ElementState) {
    ElementState["initial"] = "initial";
    ElementState["standBy"] = "standBy";
    ElementState["exited"] = "exited";
})(ElementState || (ElementState = {}));
export default function AnimatedPresence(props) {
    var _a = useState(true), hide = _a[0], setHide = _a[1];
    var cachedElement = useRef(null);
    // cache a version of the children for when it goes away return the cached version until animation is done
    var element = useMemo(function () {
        if (props.children != null) {
            var new_elements = React.Children.map(props.children, function (child) {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child);
                }
                return null;
            }).filter(function (element) { return element; });
            if (new_elements != null && new_elements.length > 0) {
                cachedElement.current = new_elements;
            }
        }
        return cachedElement.current;
    }, [props.children]);
    // check if children is present
    var isShowing = useMemo(function () {
        if (props.children == null) {
            return false;
        }
        return React.Children.toArray(props.children).filter(React.isValidElement).length > 0;
    }, [props.children]);
    var elementState = useMemo(function () {
        if (hide && isShowing) {
            return ElementState.initial;
        }
        else if (isShowing && !hide) {
            return ElementState.standBy;
        }
        else if (!isShowing) {
            return ElementState.exited;
        }
    }, [hide, isShowing]);
    // start the hide timeout when element stops showing
    useEffect(function () {
        var _a;
        var timeout;
        if (!isShowing) {
            timeout = setTimeout(function () { return setHide(true); }, props.timeout);
        }
        else {
            timeout = setTimeout(function () { return setHide(false); }, (_a = props.delay) !== null && _a !== void 0 ? _a : 0);
        }
        return function () {
            clearTimeout(timeout);
        };
    }, [isShowing]);
    // trigger styles on hide/show to start the transition
    var style = useMemo(function () {
        var _a;
        var _b, _c, _d, _e;
        var stateToStyleMap = (_a = {},
            _a[ElementState.initial] = (_b = props.initialStyle) !== null && _b !== void 0 ? _b : {
                opacity: 0,
            },
            _a[ElementState.standBy] = (_c = props.animateStyle) !== null && _c !== void 0 ? _c : {
                opacity: 1,
            },
            _a[ElementState.exited] = (_d = props.leaveStyle) !== null && _d !== void 0 ? _d : {
                opacity: 0,
            },
            _a);
        return __assign(__assign({}, props.style), ((_e = stateToStyleMap[elementState]) !== null && _e !== void 0 ? _e : {
            opacity: 0,
        }));
    }, [props.initialStyle, props.leaveStyle, elementState]);
    if (hide && !isShowing) {
        return null;
    }
    return (React.createElement(StyledPresence, { timeout: props.timeout, style: style }, element));
}
var templateObject_1;
